import { useMutation, useQuery } from "@tanstack/react-query";
import { getPlants } from "~/services/plant.service";
import {
  createPlantationData,
  getPlantationType,
  updatePlantationData,
} from "~/services/plantation.service";
import { getPlotting } from "~/services/plotting.service";

export function useCreatePlantationMutation() {
  return useMutation((payloads) => createPlantationData(payloads));
}
export function useUpdatePlantationMutation() {
  return useMutation((payloads) => updatePlantationData(payloads));
}

export function useGetPlantationTypeData() {
  return useQuery({
    queryFn: () => getPlantationType(),
    queryKey: ["plantationData"],
  });
}

export function usePlottingQueryData() {
  return useQuery({
    queryFn: () => getPlotting(),
    queryKey: ["plotting_data"],
  });
}

export function usePlantQueryData() {
  return useQuery({ queryFn: () => getPlants(), queryKey: ["plant_data"] });
}
